/** Format a duration in seconds as a human-readable string: "3m 12s", "45s" */
export function formatDuration(sec: number | null): string {
  if (sec === null) return "";
  if (sec < 60) return `${sec}s`;
  const m = Math.floor(sec / 60);
  const s = sec % 60;
  return s > 0 ? `${m}m ${s}s` : `${m}m`;
}

/** Format an ISO timestamp as a relative time string: "just now", "3m ago", "2h ago", "5d ago" */
export function formatRelativeTime(ts: string): string {
  try {
    const ms = Date.now() - new Date(ts).getTime();
    if (ms < 5000) return "just now";
    if (ms < 60_000) return `${Math.floor(ms / 1000)}s ago`;
    if (ms < 3_600_000) return `${Math.floor(ms / 60_000)}m ago`;
    if (ms < 86_400_000) return `${Math.floor(ms / 3_600_000)}h ago`;
    return `${Math.floor(ms / 86_400_000)}d ago`;
  } catch {
    return ts;
  }
}

/** Format a deployment event type as a readable label: "deployment.build_started" -> "Build Started" */
export function formatEventType(eventType: string): string {
  const parts = eventType.replace("deployment.", "").split("_");
  return parts
    .map((p, i) => (i === 0 ? p : p.charAt(0).toUpperCase() + p.slice(1)))
    .join(" ")
    .replace(/^([a-z])/, (_, c) => c.toUpperCase());
}
